<template>
  <ClinicDetail clinicEditRoute="AdminClinicEdit"></ClinicDetail>
</template>

<script>
import ClinicDetail from '@/views/components/clinics/ClinicDetailPage.vue';

export default {
  components: {
    ClinicDetail,
  },
  data: () => ({}),
};
</script>
